import { serverConfig } from '@/config/server.config'
import { RegistrationStatus } from '@/types/'
import type { LoginRequest, LoginResponse } from '@/types/authentication'

export async function login(
  loginRequest: LoginRequest,
): Promise<LoginResponse> {
  const response = await fetch(
    `${serverConfig.digitalCommunicationsApiUrl}/authentication/login`,
    {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(loginRequest),
    },
  )

  if (!response.ok) {
    // TODO - log error details
    return {
      data: null,
      registrationStatus: RegistrationStatus.Unknown,
      isSuccess: false,
      needsToLogin: true,
    }
  }

  return await response.json()
}
